import { getQuote } from './api.js';
import { STORAGE_KEYS } from './constants.js';

const quoteEl = document.querySelector('[data-quote]');

function getToday() {
  return new Date().toISOString().split('T')[0];
}

function renderQuote({ quote, author }) {
  if (!quoteEl) return;

  quoteEl.innerHTML = `
    <div class='quote-block'>
      <div class='quote-icon-wrap'>
        <svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path d='M17.7293 5.90698C17.4611 5.59399 16.9834 5.55284 16.6631 5.81384L14.5637 7.53692L13.5983 5.19977C13.564 5.11205 13.5119 5.03841 13.452 4.97342C13.2547 4.54455 12.9122 4.17633 12.44 3.96297C12.235 3.872 12.0233 3.82326 11.8116 3.79944C11.765 3.77561 11.7229 3.7442 11.6697 3.72796L7.9754 2.72184C7.76813 2.6666 7.55975 2.70234 7.38905 2.79981C7.18621 2.86696 7.0122 3.011 6.92907 3.22002L5.53802 6.71491C5.38728 7.09505 5.58014 7.52392 5.9703 7.67338C6.35824 7.82067 6.79827 7.63114 6.95012 7.24992L8.12503 4.29871L9.80759 4.75574C9.76657 4.82072 9.72224 4.88137 9.68899 4.95068L7.53204 9.51884C7.501 9.58598 7.48438 9.65421 7.46221 9.72353L4.84084 14.0177L0.453779 15.4516C-0.0427858 15.8144 -0.148084 16.4978 0.218797 16.983C0.587895 17.4692 1.28951 17.5721 1.78497 17.2137L6.274 15.7029C6.41144 15.6054 6.5112 15.4776 6.58657 15.34C6.6431 15.2816 6.70738 15.235 6.75061 15.1624L8.31346 12.6022L11.0878 14.9123L8.11949 18.1808C7.71049 18.6313 7.7515 19.3255 8.21481 19.7241C8.67702 20.1259 9.38528 20.0836 9.7965 19.6309L13.5008 15.5534C13.6161 15.4278 13.6848 15.2826 13.7313 15.131C13.759 15.0487 13.759 14.9632 13.7657 14.8776C13.7657 14.8343 13.7823 14.7953 13.779 14.7552C13.769 14.4563 13.6449 14.1661 13.3944 13.9592L10.8417 11.8322C11.0257 11.661 11.182 11.4574 11.2951 11.2181L12.9488 7.71887L13.4786 9.09754C13.5008 9.21992 13.5429 9.34014 13.6316 9.44086C13.7114 9.534 13.8134 9.59573 13.922 9.63905C13.9331 9.64447 13.9464 9.64555 13.9597 9.6488C14.0284 9.67263 14.0982 9.69537 14.1703 9.69862C14.2556 9.7062 14.3421 9.69537 14.4296 9.67154C14.4318 9.67046 14.4329 9.67046 14.4329 9.67046C14.4562 9.66504 14.4795 9.66938 14.5028 9.65963C14.6258 9.61414 14.72 9.53725 14.8009 9.44736L17.8136 6.94884C18.1339 6.68567 17.9987 6.21997 17.7293 5.90698Z' fill='#F4F4F4'/>
          <path d='M13.9191 4.12629C15.0853 4.12629 16.0306 3.20259 16.0306 2.06314C16.0306 0.923701 15.0853 0 13.9191 0C12.753 0 11.8076 0.923701 11.8076 2.06314C11.8076 3.20259 12.753 4.12629 13.9191 4.12629Z' fill='#F4F4F4'/>
        </svg>
      </div>
      <div class='quote-text'>
        <h3 class='quote-title'>Quote of the day</h3>
        <p class='quote-body'>${quote}</p>
      </div>
    </div>
    <p class='quote-author'>${author}</p>
    <svg class='quote-commas' width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z' fill='#f4f4f4'/>
    </svg>
  `;
}

async function initQuote() {
  if (!quoteEl) return;

  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEYS.quote));
    const today = getToday();

    if (saved && saved.date === today) {
      renderQuote(saved.data);
      return;
    }

    const data = await getQuote();

    localStorage.setItem(
      STORAGE_KEYS.quote,
      JSON.stringify({
        date: today,
        data,
      })
    );

    renderQuote(data);
  } catch {
    quoteEl.innerHTML = '<p>Quote is temporarily unavailable.</p>';
  }
}

initQuote();
